import { Grid, Tab, Tabs } from "@mui/material";
import { fetchUsers } from "actions/userActions";
import { selectCustomerDetails } from "features/customer";
import { selectUsers } from "features/users";
import { useApiOnce, useAppSelector } from "hooks/hooks";
import { useState } from "react";
import { useFeatureFlag } from "utilities/featureFlag";
import { CompanyDetails } from "./CompanyDetails/CompanyDetails";
import { CompanyDocuments } from "./CompanyDocuments";
import { CompanyInfoSection } from "./CompanyInfoSection";
import { CompanyNotifications } from "./CompanyNotifications";
import { CompanyProducts } from "./CompanyProducts";
import styles from "./MyCompany.module.scss";

const MyCompanyPageTabs = {
	Details: {
		label: "Users & Roles",
		value: 0,
	},
	Products: {
		label: "Products",
		value: 1,
	},
	Documents: {
		label: "Documents",
		value: 2,
	},
	Notifications: {
		label: "Notifications",
		value: 3,
	},
};

const MyCompany = () => {
	const isNotificationCenterEnabled = useFeatureFlag("notification-center");
	useApiOnce(fetchUsers, useAppSelector(selectUsers));
	const [activeTab, setActiveTab] = useState(MyCompanyPageTabs.Details.value);

	const handleTabChange = (tab: number) => {
		// Check if any unsaved changes are present
		setActiveTab(tab);
		// Also set the active tab in our redux store
		// Also scroll to the top of the page
	};

	const customerInfo = useAppSelector(selectCustomerDetails);

	const tabContent = () => {
		switch (activeTab) {
			case MyCompanyPageTabs.Details.value:
				return <CompanyDetails />;
			case MyCompanyPageTabs.Products.value:
				return <CompanyProducts customerInfo={customerInfo} />;
			case MyCompanyPageTabs.Documents.value:
				return <CompanyDocuments />;
			case MyCompanyPageTabs.Notifications.value:
				return isNotificationCenterEnabled ? <CompanyNotifications /> : null;
			default:
				return <CompanyDetails />;
		}
	};

	return (
		<Grid container className={styles.wrapper}>
			<CompanyInfoSection customerInfo={customerInfo} />
			<Grid container className={styles.tabsContainer}>
				<Tabs value={activeTab} onChange={(e, tab) => handleTabChange(tab)}>
					<Tab
						label={MyCompanyPageTabs.Details.label}
						value={MyCompanyPageTabs.Details.value}
						className={styles.tab}
						classes={{ selected: styles.selectedTab }}
					/>
					{/*
					// TODO: Re-introduce this tab if Steffen (UX) wants to keep it
					 <Tab
						label={MyCompanyPageTabs.Products.label}
						value={MyCompanyPageTabs.Products.value}
						className={styles.tab}
					/> */}
					<Tab
						label={MyCompanyPageTabs.Documents.label}
						value={MyCompanyPageTabs.Documents.value}
						className={styles.tab}
						classes={{ selected: styles.selectedTab }}
					/>
					{isNotificationCenterEnabled && (
						<Tab
							label={MyCompanyPageTabs.Notifications.label}
							value={MyCompanyPageTabs.Notifications.value}
							className={styles.tab}
							classes={{ selected: styles.selectedTab }}
						/>
					)}
				</Tabs>
			</Grid>
			{tabContent()}
		</Grid>
	);
};

export { MyCompany };
